import { validations } from "./validations";

export const formRules: any = {
  name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(1, field),
    validations.max.text(max, field),
  ],
  last_name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(1, field),
    validations.max.text(max, field),
  ],
  phone: (field?: string) => [
    validations.required.text(field),
    validations.pattern.phone,
  ],
  mobileNumber: (field?: string) => [
    validations.pattern.mobileNumber(field),
  ],
  email: (field?: string) => [
    validations.required.text(field),
    validations.email(field),
  ],
  password: (min = 8, max = 12, field?: string) => [
    validations.required.text(field),
    validations.pattern.password(field),
    validations.min.text(min),
    validations.max.text(max),
  ],
  custom: ({
    required = true,
    min = 3,
    max,
    firstLetterUpperCase,
    field,
  }: {
    required?: boolean;
    min?: number;
    max?: number;
    firstLetterUpperCase?: boolean;
    field?: string;
  } = {}) => {
    const customRules: any = [];
    required && customRules.push(validations.required.text(field));
    min && customRules.push(validations.min.text(min, field));
    max && customRules.push(validations.max.text(max, field));
    firstLetterUpperCase &&
      customRules.push(validations.pattern.firstLetterUpperCase);

    return customRules;
  },
};
